import { Eye, Megaphone, Tag, CalendarRange, Newspaper, Users, Building2, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal, SectionHead } from "@/components/Reveal";

const ADVANTAGES = [
  { icon: Eye, label: "Visibilité" },
  { icon: Megaphone, label: "Communication" },
  { icon: Tag, label: "Offres exclusives" },
  { icon: CalendarRange, label: "Événements" },
  { icon: Newspaper, label: "Publications" },
  { icon: Users, label: "Présence auprès de la communauté" },
];

export default function Partners() {
  return (
    <section id="partenaires" className="py-16 md:py-24 lg:py-32" data-testid="partners-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-center gap-14 lg:grid-cols-2">
          <div>
            <SectionHead
              eyebrow="Partenaires"
              title="Devenez partenaire du Motards Business Club 84."
              sub="Associez votre marque à une communauté active de motards, d'entrepreneurs et de professionnels."
            />
            <Reveal delay={0.15}>
              <div className="mt-9 grid grid-cols-2 gap-4 sm:grid-cols-3" data-testid="partners-advantages">
                {ADVANTAGES.map((a) => (
                  <div key={a.label} className="group flex items-center gap-3 rounded-xl border border-border bg-card p-4 transition-all duration-300 hover:border-mbcg/50">
                    <a.icon className="h-4.5 w-4.5 h-[18px] w-[18px] shrink-0 text-gold transition-colors duration-300 group-hover:text-mbcg" strokeWidth={1.8} />
                    <span className="text-xs font-semibold leading-tight text-foreground/90">{a.label}</span>
                  </div>
                ))}
              </div>
              <Link
                to="/contact?sujet=Devenir%20partenaire"
                data-testid="partners-become-cta"
                className="btn-sheen mt-10 inline-flex items-center gap-3 rounded-full bg-mbcg px-8 py-4 text-sm font-bold uppercase tracking-[0.14em] text-night transition-all duration-300 hover:bg-mbcg-hover hover:scale-[1.03]"
              >
                Devenir partenaire <ArrowRight className="h-4 w-4" />
              </Link>
            </Reveal>
          </div>

          <Reveal delay={0.1}>
            <div className="rounded-3xl border border-border bg-night-soft p-8 sm:p-10" data-testid="partners-logo-grid">
              <p className="eyebrow mb-6">Ils nous accompagnent</p>
              <div className="grid grid-cols-2 gap-4 sm:grid-cols-3">
                {[1, 2, 3, 4, 5, 6].map((n) => (
                  <div
                    key={n}
                    className="flex h-24 flex-col items-center justify-center gap-2 rounded-xl border border-dashed border-border bg-card/60 text-muted-foreground/60 transition-colors duration-300 hover:border-gold/40 hover:text-gold/70"
                    data-testid={`partners-logo-placeholder-${n}`}
                  >
                    <Building2 className="h-5 w-5" strokeWidth={1.5} />
                    <span className="px-2 text-center text-[10px] font-medium uppercase tracking-wider">Votre logo ici</span>
                  </div>
                ))}
              </div>
              <p className="mt-6 text-xs leading-relaxed text-muted-foreground">
                Emplacements réservés aux logos des partenaires officiels du club — ils seront ajoutés dès la signature
                des premiers partenariats.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
